import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import DemoTourBar from "@/components/DemoTourBar";
import HomePage from "@/pages/HomePage";
import ExplorePage from "@/pages/ExplorePage";
import MatchmakerPage from "@/pages/MatchmakerPage";
import SolutionPage from "@/pages/SolutionPage";
import OrganizerPage from "@/pages/OrganizerPage";
import ProfilePage from "@/pages/ProfilePage";

function App() {
  return (
    <div className="App bg-slate-50 text-slate-900">
      <AuthProvider>
        <BrowserRouter>
        <Header />
        <main className="min-h-[70vh]">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/jelajahi" element={<ExplorePage />} />
            <Route path="/matchmaker" element={<MatchmakerPage />} />
            <Route path="/solusi" element={<SolutionPage />} />
            <Route path="/organizer" element={<OrganizerPage />} />
            <Route path="/profil" element={<ProfilePage />} />
          </Routes>
        </main>
        <Footer />
        <DemoTourBar />
        <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
